<template>
    <div class="app">
        <div>
            <!--        地图信息    -->
            <div class="address-container">


                <div id="mapContainer"></div>

                <div class="address-info">
                    <p>小区：{{ oDetails.address }}</p>
                </div>

                <div class="title-box">
                    <p>用户真实安装实例</p>
                    <!-- <div class="eva-star-i">
                        <p>整体评价</p>
                        <img :src="require('@/assets/images/case/detail/star-sm-icon.png')" v-for="i in 5" :key="i" alt="">
                    </div> -->
                    <div class="eva-star-i">
                        <p>城市：{{ oDetails.city_name }}</p>
                    </div>
                </div>

                <!--            更多案例按钮    -->
                <!--                <div v-if="true" @click="navToMapModel" class="more-project">-->
                <!--                    <img :src="require('@/assets/images/case/detail/search-sm-icon.png')" alt="">-->
                <!--                    <p>更多案例</p>-->
                <!--                </div>-->
            </div>

            <!--        评论信息     -->
            <div v-if="oDetailsObj.score != undefined" class="evaluate-wrap-container">
                <!--              用户信息  -->
                <div class="user-info">
                    <img :src="oDetailsObj.headimgurl" class="head-image" />
                    <div class="info">
                        <p class="title">{{ oDetailsObj.nickname ? oDetailsObj.nickname : 'A.O.史密斯(默认)' }}</p>
                        <p class="model-info">{{ oDetails.tagsArr }}</p>
                    </div>
                    <p class="time-info">{{ oDetails.createdate }}</p>
                </div>
                <!-- 评分 -->
                <div class="eva-star-i">
                    <p>整体评价</p>
                    <div class="start_icon" v-for="(iconItem, iconIndex) in 5" :key="iconIndex">
                        <img class="start-quan-img"
                            v-if="iconIndex <= toFix(Number(oDetailsObj.score ? oDetailsObj.score.main_score : 0)) - 1"
                            src="https://pro-core.babycdn.com/2021/aosmith/lottery/images2020/watersystem/case/details/start.png" />
                        <img class="start-left-img"
                            v-if="count(Number(oDetailsObj.score ? oDetailsObj.score.main_score : 0)) && iconIndex == toFix(Number(oDetailsObj.score ? oDetailsObj.score.main_score : 0))"
                            src="https://pro-core.babycdn.com/2021/aosmith/lottery/images2020/watersystem/case/details/left_start.jpg" />
                    </div>
                </div>
                <!-- -            评价文字    -->
                <div class="evaluate-content">
                    <p :class="{ 'mini-content': evaContextEllipsis }">
                        {{ oDetailsObj.score ? oDetailsObj.score.content : '' }}</p>
                </div>
                <!--              底部栏  -->
                <div class="action-wrap">
                    <!-- <p @click="changEvaContentEll" class="look-all" :class="{'look-all-ac':!evaContextEllipsis}">
                        查看全文
                        <img :src="require('@/assets/images/case/detail/down-mini-icon.png')" alt="">
                    </p> -->

                    <div class="icon-wrap">
                        <div class="item">
                            <img :src="require('@/assets/images/case/detail/watch-mini-icon.png')" class="icon" alt="">
                            <p>{{ oDetails.views }}</p>
                        </div>
                        <div class="item">
                            <img :src="require('@/assets/images/case/detail/save-mini-icon.png')" class="icon" alt="">
                            <p>{{ oDetails.collect_num }}</p>
                        </div>
                        <div class="item">
                            <img :src="require('@/assets/images/case/detail/share-mini-icon.png')" class="icon" alt="">
                            <p>{{ oDetails.share_num }}</p>
                        </div>

                    </div>
                </div>
            </div>


            <div class="case-list">
                <!--                <div class="case-item" v-if="oDetails.genre_img">-->
                <!--                    <h5>口碑晒单</h5>-->
                <!--                    <div class="image-wrap">-->
                <!--                        <img v-lazy="oDetails.genre_image[0].img_url" alt="图片"/>-->
                <!--                    </div>-->
                <!--                </div>-->
                <div class="title-b">案例应用场景</div>
                <div class="case-item" v-for="item in oDetails.new_scenes" :key="item.id">
                    <!--                 图片容器   -->
                    <div class="image-wrap">
                        <!--            场景名称            -->
                        <div class="scene-title-b">{{ item.scenes_name ? item.scenes_name + "场景" : "" }}</div>
                        <!--             小三角           -->
                        <div class="triangle"></div>

                        <img v-for="(imgitem, imgindex) in item.house_img" :key="imgindex" v-lazy="imgitem.img_url"
                            alt="图片" @click="swiperChange(item.arrImg, imgindex)" />
                        <div class="viebeo" v-if="item.mp4">
                            <video :id="`video${item.id}`" :src="item.mp4_info.mp4_url" controls
                                :poster="item.mp4_info.mp4_rectangle_cover_url" webkit-displaying-fullscreen="false"
                                x-webkit-airplay="true" x5-playsinline="true" webkit-playsinline="true"
                                playsinline="true"></video>
                        </div>
                    </div>


                    <div class="goods-wrap" v-if="item.goods_info.length">
                        <div class="titel">
                            <p>案例场景同款商品</p>
                            <div class="look-same-goods">商品详情</div>
                        </div>
                        <ul class="goods-list">
                            <li v-for="git in item.goods_info" :key="git.id" v-if="git.id" @click="godetails(git)">
                                <img class="img-box" :src="git.mobile_thumb" alt="" />
                                <div class="title">
                                    <div class="name-t">{{ git.goods_type_name }}</div>
                                    <div class="type-t">{{ git.goods_name }}</div>
                                    <div class="selling" v-for="(gitem, gindex) in git.attr" :key="gindex"
                                        v-if="gitem.attr_mean < 4 && gindex < 3">
                                        <span>{{ gitem.attr_value ? "·" : "" }}</span>{{ gitem.attr_value }}
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>

            <!--        分享按钮    -->
            <!--            <div @click="getShare()" class="share-btn-wrap">-->
            <!--                <img :src="require('@/assets/images/case/detail/share&#45;&#45;white-icon.png')" alt="">-->
            <!--                <p>分享案例</p>-->
            <!--            </div>-->

            <!--            <div class="btn">-->
            <!--                &lt;!&ndash;                <div&ndash;&gt;-->
            <!--                &lt;!&ndash;                    class="collection"&ndash;&gt;-->
            <!--                &lt;!&ndash;                    :class="{'cancel-coll': oDetails.is_collect === 1}"&ndash;&gt;-->
            <!--                &lt;!&ndash;                    @click.stop="getcollection"&ndash;&gt;-->
            <!--                &lt;!&ndash;                >&ndash;&gt;-->
            <!--                &lt;!&ndash;                    <img :src="require('@/assets/images/case/detail/save-icon.png')" alt="">&ndash;&gt;-->
            <!--                &lt;!&ndash;                    <p>{{ oDetails.is_collect === 0 ? '收藏本条案例' : '取消收藏案例' }}</p>&ndash;&gt;-->
            <!--                &lt;!&ndash;                </div>&ndash;&gt;-->

            <!--                <div v-if="true" @click="watchNearShop" class="collection">-->
            <!--                    <img :src="require('@/assets/images/case/detail/shop-icon.png')" alt="">-->
            <!--                    <p>查看附近门店</p>-->
            <!--                </div>-->

            <!--            </div>-->


            <!-- 分享提示弹窗 -->
            <div v-if="bShow">
                <div class="popup" @click.stop="bShow = false"></div>
                <div class="kuang">
                    <div class="top">是否在分享案例中添加引流活动？</div>
                    <div class="bottom">
                        <div @click="gosarelink">直接分享</div>
                        <div @click="gosarea">添加活动</div>
                    </div>
                </div>
            </div>
            <!-- 预览图片 -->
            <div class="preview-img" v-show="showSwiper">
                <swiper :options="swiperOption" ref="mySwiper">
                    <swiper-slide v-for="item in arrSwiperImg" :key="item.id">
                        <div class="swiper-zoom-container">
                            <img :src="item" alt />
                        </div>
                    </swiper-slide>
                    <!--<div class="swiper-pagination "  slot="pagination"></div>-->
                </swiper>
            </div>
            <div v-show="showSwiper" class="close-preview" @click="closeSwiper">
                关闭预览
            </div>
            <!-- 预览头图 -->
            <div class="preview-img" v-show="headerSwiper">
                <swiper :options="swiperOptiontwo" ref="mySwipertwo">
                    <swiper-slide v-for="item in arrHeaderImg" :key="item.id">
                        <div class="swiper-zoom-container">
                            <img :src="item" alt />
                        </div>
                    </swiper-slide>
                    <div class="swiper-pagination" slot="pagination"></div>
                </swiper>
            </div>
            <div v-show="headerSwiper" class="close-preview" @click="getheaderSwiper">
                关闭预览
            </div>
        </div>

        <div class="logo">
            <img src="@/assets/images/system/logoV2.png" />
        </div>


        <!--    操作按钮  -->
        <div class="action-btn">
            <div @click="toCaseList" class="collection">
                <img :src="require('@/assets/images/ant/watch-more-pr.png')" alt="">
                <div>查看身边更多案例</div>
            </div>

            <div @click="toNearby" class="collection">
                <img :src="require('@/assets/images/ant/shop-icon.png')" alt="">
                <div>查看附近门店</div>
            </div>
        </div>



    </div>
</template>
<script>
import path from "@/path.js";
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import MapLoader from "@/libs/AMap";
import { requestAesPost5 } from "@/libsV2/requestAes";


export default {
    components: {
        Swiper,
        SwiperSlide,
    },
    data() {
        return {
            oDetailsObj: {},//案例分数。评语
            // 全文省略
            evaContextEllipsis: true,
            oDetails: {}, //案例详情
            headimg: "",
            bShow: false,
            showSwiper: false, //预览图片
            headerSwiper: false, //预览头图
            arrHeaderImg: [], //头图
            arrSwiperImg: [], //需要预览的图片
            swiperIndex: 0,
            swiperIndextwo: 0,
            swiperOption: {
                clickable: true,
                noSwiping: true,
                zoom: true,
                on: {
                    slideChangeTransitionStart: function (swiper) {
                        this.swiperIndex = this.swiper?.activeIndex;
                    }.bind(this),
                },
            },
            swiperOptiontwo: {
                clickable: true,
                noSwiping: true,
                zoom: true,
                on: {
                    slideChangeTransitionStart: function (swipertwo) {
                        this.swiperIndextwo = this.swipertwo?.activeIndex;
                    }.bind(this),
                },
            },
            userinfo: {}, //用户信息
        };
    },
    created() {
        this.headimg = this.$route.query.headimg;
        this.$store.commit("loadSwitch", true);
        this.getDetails();
    },
    mounted() {
        this.$nextTick(() => {
            // 百度数据统计
            // _hmt.push(['_trackPageview', '/case/map/v2/details']);
        })
    },
    computed: {
        swiper() {
            this.swiperIndex = this.$refs.mySwiper.swiper?.activeIndex;
            //  console.log("实例", this.swiperIndex);
            return this.$refs.mySwiper.swiper;
        },
        swipertwo() {
            this.swiperIndextwo = this.$refs.mySwipertwo.swiperIndextwo?.activeIndex;
            return this.$refs.mySwipertwo.swiperIndextwo;
        },
    },
    methods: {
        oo() {
            console.log('09')
        },
        toFix(value) {
            if (value >= 4.9) {
                value = 5
            }
            return parseInt(value)
        },
        count(value) {
            let num = parseInt(value);
            if (value - num > 0.1) {
                return 1
            } else {
                return 0
            }
        },

        // 跳转更多案例
        navToMapModel() {
            wx.miniProgram.navigateTo({ url: "/praise/pages/case/map/index" });
        },

        // 跳转列表模式
        toCaseList() {
            this.$router.push({path:'/case/map/v2/lists',query:{ald_source:this.$route.query.ald_source || '',track_action:'share_vertical_media',track_id:this.$route.query.ald_source || 'h5',track_uuid:sessionStorage.getItem('page_uuid')}})
        },

        /**
         * 查看全文点击
         */
        changEvaContentEll() {
            this.evaContextEllipsis = !this.evaContextEllipsis;
        },
        initMap() {
            MapLoader().then((AMap) => {
                const { plot: { latitude, longitude } } = this.oDetails;
                const map = new AMap.Map("mapContainer", {
                    center: [longitude, latitude],
                    expandZoomRange: true,
                    zoom: 16,
                    dragEnable: false, // 地图是否可通过鼠标拖拽平移，默认为true
                    keyboardEnable: false, //地图是否可通过键盘控制，默认为true
                    doubleClickZoom: false, // 地图是否可通过双击鼠标放大地图，默认为true
                    scrollWheel: true,
                    logo: false
                });

                // 当前位置标注
                const markerNow = new AMap.Marker({
                    position: new AMap.LngLat(
                        longitude,
                        latitude
                    ),
                    content: '<div class="ant-map-marker-blue_v2">' + "</div>",
                    // offset: new AMap.Pixel(-42, -125),
                    animation: "AMAP_ANIMATION_DROP", // AMAP_ANIMATION_BOUNCE
                });

                map.add([markerNow]);
            })
        },
        // 分享判断
        getShare() {
            this.bShow = true;
        },
        //点击打开预览
        swiperChange(arr, index) {
            var that = this;
            //  console.log(index);
            if (index >= 0) {
                that.showSwiper = true;
                this.arrSwiperImg = [];
                this.arrSwiperImg = arr;
                that.swiper?.slideTo(index, 1000, true);
            }
        },
        //点击关闭预览
        closeSwiper() {
            var that = this;
            that.showSwiper = false;
        },
        //点击打开预览头图
        headerChange(index) {
            var that = this;
            //  console.log(index);
            if (index >= 0) {
                that.headerSwiper = true;
                that.swiper.slideTo(index, 1000, true);
            }
        },
        //点击关闭预览头图
        getheaderSwiper() {
            var that = this;
            that.headerSwiper = false;
        },
        //点击跳转详情页
        godetails(item) {
            //  console.log("商品id", id);
            this.$router.push({ path: "/shopp/details", query: { id: item.id } });
        },
        //跳转直接
        // gosarelink() {
        //     this.bShow = false;
        //     this.$store.commit("loadSwitch", true);
        //     path.post5(path.getUser, {user_id: this.$route.query.tp5Userid})
        //         .then((res) => {
        //             //  console.log("用户信息", res);
        //             this.userinfo = res.data.data.result;
        //             this.$store.commit("loadSwitch", false);
        //             if (res.data.data.result.sell_id == 0) {
        //                 // this.$toast({
        //                 //   message: "您不是直销员",
        //                 //   duration: 500,
        //                 // });
        //                 // setTimeout(() => {
        //                 wx.miniProgram.navigateTo({
        //                     url: `/pages/phoneauth/index?url=/pages/case/share/index&userid=${this.$route.query.userid}&topicid=${this.$route.query.topicid}`,
        //                 });
        //                 // }, 500);
        //             } else {
        //                 wx.miniProgram.navigateTo({
        //                     url: `/pages/case/share/index?userid=${this.$route.query.userid}&topicid=${this.$route.query.topicid}`,
        //                 });
        //             }
        //         });
        // },

        // //跳转添加活动页面
        // gosarea() {
        //     this.bShow = false;
        //     this.$store.commit("loadSwitch", true);
        //     path.post5(path.getUser, {user_id: this.$route.query.tp5Userid})
        //         .then((res) => {
        //             //  console.log("用户信息", res);
        //             this.userinfo = res.data.data.result;
        //             this.$store.commit("loadSwitch", false);
        //             if (this.userinfo.sell_id == 0) {
        //                 // this.$toast({
        //                 //   message: "您不是直销员",
        //                 //   duration: 500,
        //                 // });
        //                 // setTimeout(() => {
        //                 wx.miniProgram.navigateTo({
        //                     url: `/pages/phoneauth/index?url=/pages/watersystem/activity/index&userid=${this.$route.query.userid}&topicid=${this.$route.query.topicid}&from=case`,
        //                 });
        //                 // }, 500);
        //             } else {
        //                 wx.miniProgram.navigateTo({
        //                     url: `/pages/watersystem/activity/index?userid=${this.$route.query.userid}&topicid=${this.$route.query.topicid}&from=case`,
        //                 });
        //             }
        //         });
        // },
        /**
         * 查看附近的门店
         */
        watchNearShop() {
            wx.miniProgram.navigateTo({
                url: ``,
            });
        },
        //收藏案例
        getcollection() {
            let data = {
                type: "topic",
                user_id: this.$route.query.tp5Userid,
                xid: this.oDetails.id,
                title:
                    this.oDetails.province_name +
                    "-" +
                    this.oDetails.city_name +
                    "-" +
                    this.oDetails.address,
                source: "xcx",
            };
            this.$store.commit("loadSwitch", true);
            requestAesPost5(path.TOPIC_AES_COLLECT, data).then((res) => {
                //  console.log("收藏案例", res);
                if (res.data.error == 0) {
                    this.$store.commit("loadSwitch", false);
                    this.$toast({
                        message: res.data.data.result.msg,
                        duration: 500,
                    });
                    // this.getDetails(); 收藏无需刷新数据
                    this.oDetails.is_collect = this.oDetails.is_collect === 0 ? 1 : 0;
                }
            });
        },
        getDetails() {
            let data = {
                topic_id: this.$route.query.topicid,
                source: "xcx",
                user_id: this.$route.query.userid,
                is_share: 0,
            };
            this.$store.commit("loadSwitch", true);
            requestAesPost5(path.TOPIC_AES_TOPIC, data).then(async (res) => {
                if (res.data.error == 0) {
                    this.$store.commit("loadSwitch", false);


                    const detail = res.data.data.result;

                    // const tagList = detail.title.split('-').filter(i => i !== 'm²');
                    // detail.title_n = tagList[0] + '-' + tagList[1];
                    // detail.tagsArr = tagList.filter((i, index) => index >= 2 && i).map(i => i.split(',')).flat().filter(i => i).map((i, ind) => ({
                    //     id: ind,
                    //     type_name: i
                    // }))
                    // detail.tagsArr = tagList.filter((i, index) => index >= 2 && i).map(i => i.split(',')).flat().filter(i => i).reduce((pre, i) => `${pre} ·${i}`, '')
                    let arrGoods = [];
                    detail.new_scenes.forEach(it => {
                        arrGoods = arrGoods.concat(it.device_info);
                    })
                    detail.tagsArr = '·' + detail.house_area + 'm² · ' + arrGoods.join(' · ');

                    this.oDetails = detail;
                    console.log(this.oDetails, '0901')


                    let arrNewscenes = res.data.data.result.new_scenes;
                    let arrSwiperImg = [];
                    let arrHeaderImg = [];
                    arrHeaderImg.push(res.data.data.result.cover);
                    this.arrHeaderImg = arrHeaderImg;
                    arrNewscenes.forEach((it) => {
                        it.arrImg = [];
                        it.house_img.forEach((img) => {
                            it.arrImg.push(img.img_url);
                            // console.log(img.img_url)
                            // arrSwiperImg.push(img.img_url)
                            // this.arrSwiperImg=arrSwiperImg;
                            // console.log(this.arrSwiperImg)
                        });
                        // if (it.mp4 != "") {
                        //   console.log(it);
                        //   this.formLabelAlign(it.id);
                        // }
                    });

                    this.initMap();
                }
            });

            requestAesPost5(path.TOPIC_AES_DETAIL, data).then(_result => {
                this.oDetailsObj = _result.data.data.result
                console.log(this.oDetailsObj, '09')
            })

        },
        formLabelAlign(id) {
            //  console.log("canvas", id);
            this.$nextTick(() => {
                let video = document.getElementById("video" + id);
                video.currentTime = 1;
                video.crossOrigin = "Anonymous"; //canvas跨域获取图片
                //  console.log(video);
                video.addEventListener("loadeddata", function () {
                    //  console.log("视频加载完毕");
                    let canvas = document.createElement("canvas");
                    canvas.width = video.clientWidth;
                    canvas.height = video.clientWidth;
                    // video.crossOrigin = 'Anonymous' //canvas跨域获取图片
                    canvas
                        .getContext("2d")
                        .drawImage(video, 0, 0, canvas.width, canvas.width);
                    let img = document.createElement("img");
                    let imgsrc = canvas.toDataURL("image/png");
                    //  console.log(imgsrc);
                    video.poster = canvas.toDataURL("image/png");
                    // console.log(video)
                });
            });
        },
        toNearby() {  // 附近门店
            //  let data ={
            //       type:'topic',
            //       type_id:this.$route.query.topicid,
            //       action:'click',
            //       element:'store',
            //       page_url:'/case/map/v2/details'
            //     }
            //   this.$store.commit("loadSwitch", true);
            //   requestAesPost5(path.BROWSE_STATISTICS, data).then((res) => {
            //     this.$store.commit("loadSwitch", false);
            //     this.$router.push({ path: '/case/map/v2/store',query:{topicId:this.$route.query.topicid} })
            //   });
            // this.$common.redirect('/case/map/v2/store', {
            //     topicId: this.$route.query.topicid
            // })
            this.$router.push({path:'/case/map/v2/store',query:{topicId:this.$route.query.topicid,ald_source:this.$route.query.ald_source || '',track_action:'share_vertical_media',track_id:this.$route.query.ald_source || 'h5',track_uuid:sessionStorage.getItem('page_uuid')}})
        },
    },
};
</script>
<style lang="scss" scoped>
@import 'details.scss';
</style>
